import { IGenList, QList, GenData } from '@educraft/base';

/**
 * A list generator that creates items from a number sequence.
 * Port of C# EduFrame.OrderGen.Generators.NumberArray.
 */
export class NumberArrayGen implements IGenList {

  private readonly numbers: number[];
  private readonly valueFunc: (n: number) => string;

  constructor(numbers: Iterable<number>, valueFunc: (n: number) => string) {
    this.numbers = [...numbers];
    this.valueFunc = valueFunc;
  }

  generate(data: GenData): QList {
    return {
      items: this.numbers.map((n) => ({
        key: n.toString(),
        value: this.valueFunc(n),
      })),
    };
  }
}
